const getters = {
  sidebar: state => state.app.sidebar, // 侧边栏状态
  device: state => state.app.device, // desktop(pc) or mobile
  token: state => state.user.token, // token
  deadline: state => state.user.deadline, // deadline
  userinfo: state => state.user.userinfo, // 用户信息
  roles: state => state.user.roles, // 用户角色权限数组
  menus: state => state.user.menus, // 后台接口获取的用户左侧菜单权限数组
  // cachedViews: state => state.keepAlive.cachedViews,
    visitedViews: state => state.tagsView.visitedViews,
    cachedViews: state => state.tagsView.cachedViews,
}
export default getters



// WEBPACK FOOTER //
// ./src/store/getters.js